"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MILLISECONDS = {
    ONE_DAY: 86400000,
    ONE_HOUR: 3600000,
    ONE_MINUTE: 60000,
    ONE_SECOND: 1000,
};
exports.toTwoDigits = function (num) { return ("0" + num).slice(-2); };
//# sourceMappingURL=date.js.map